import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { NavLink, useParams } from 'react-router-dom';

import { Loader, Placeholder } from 'rsuite';


import 'sweetalert/dist/sweetalert.css';

import SweetAlert from 'sweetalert-react';

import ArchitectureServerVisitsAddModal from './architectureServerVisits_add';
import ArchitectureServerVisitsActivityModal from './architectureServerVisits_Activity';
import ArchitectureServerVisitsDateModal from './architectureServerVisits_Date';
import ArchitectureServerVisitsTimeModal from './architectureServerVisits_Time';
import ArchitectureServerVisitsStaffModal from './architectureServerVisits_Staff';

import Popup from '../../../components/popup';

import {
    retrieve, trash
} from './actions/arcServerVisits';

export default function ArchitectureServerVisits() {
    const { server_id } = useParams();
    const server_visits_data = useSelector(state => state.ARCServerVisitsReducer, shallowEqual);
    const [createModalVisibility, setCreateModalVisibility] = useState(false);
    const [createModalVisibilityActivity, setCreateModalVisibilityActivity] = useState(false);
    const [createModalVisibilityDate, setCreateModalVisibilityDate] = useState(false);
    const [createModalVisibilityTime, setCreateModalVisibilityTime] = useState(false);
    const [createModalVisibilityStaff, setCreateModalVisibilityStaff] = useState(false);
    // For Pagination Part
    const [firstIdHandlerForPagination, setFirstIdHandlerForPagination] = useState([]);
    const [lastIdHandlerForPagination, setLastIdHandlerForPagination] = useState([]);

    const [visit_id, setVisitId] = useState(0)
    // For Pagination Part

    let handleCreateModalVisibility = () => {
        setCreateModalVisibility(!createModalVisibility);
    }




    let updateParentState = () => {
        setCreateModalVisibility(!createModalVisibility);
    }
    let updateParentStateActivity = () => {
        setCreateModalVisibilityActivity(!createModalVisibilityActivity);
    }
    let updateParentStateDate = () => {
        setCreateModalVisibilityDate(!createModalVisibilityDate);
    }
    let updateParentStateTime = () => {
        setCreateModalVisibilityTime(!createModalVisibilityTime);
    }
    let updateParentStateStaff = () => {
        setCreateModalVisibilityStaff(!createModalVisibilityStaff);
    }
    const initial_single_data = {
        id: '',
        record_data: {}
    };
    const [single_data, setSingleData] = useState(initial_single_data);
    const [record_length, setRecordLength] = useState(10);
    const [page, setPage] = useState(0);
    const [showTrashAlert, setShowTrashAlert] = useState({ show: false });
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const fetchServerVisits = recordLength => {
        setLoading(true);
        let data = {
            server_id: server_id,
            limit: recordLength,
            last_id: '',
            first_id: '',
        };
        dispatch(retrieve(data)).then((response) => {
            setLoading(false);
            // For Pagination Part
            let firstIDArr = firstIdHandlerForPagination;
            let lastIDArr = lastIdHandlerForPagination;
            firstIDArr.push(response && response.first_id);
            lastIDArr.push(response && response.last_id);
            setFirstIdHandlerForPagination(firstIDArr);
            setLastIdHandlerForPagination(lastIDArr);
            // For Pagination Part
        });
    }

    useEffect(() => {
        fetchServerVisits(record_length);
    }, []);

    let handleChange = (e) => {
        if (e.target.name == 'record_length') {
            setRecordLength(e.target.value);
            fetchServerVisits(e.target.value);
        }
    }

    let handlePrev = () => {
        console.log(firstIdHandlerForPagination);
        setLoading(true);
        let data = {
            server_id: server_id,
            limit: record_length,
            last_id: '',
            first_id: firstIdHandlerForPagination[firstIdHandlerForPagination.length - 2],
        };
        dispatch(retrieve(data)).then(() => {
            setPage(page > 0 ? page - 1 : page)
            setLoading(false)
            // For Pagination Part
            let firstIDArr = firstIdHandlerForPagination.slice(0, firstIdHandlerForPagination.length - 1);
            let lastIDArr = lastIdHandlerForPagination.slice(0, lastIdHandlerForPagination.length - 1);
            setFirstIdHandlerForPagination(firstIDArr);
            setLastIdHandlerForPagination(lastIDArr);
            // For Pagination Part
        });
    }
    let handleNext = () => {
        setLoading(true);
        setPage((
            page <= (
                parseInt((
                    server_visits_data &&
                        server_visits_data.data &&
                        server_visits_data.data.total ? server_visits_data.data.total : 1
                ) / record_length) + 1
            ))
            ? page + 1
            : page
        );
        let data = {
            server_id: server_id,
            limit: record_length,
            last_id: server_visits_data.data.last_id,
            first_id: '',
        };
        dispatch(retrieve(data)).then((response) => {
            // For Pagination Part
            let firstIDArr = firstIdHandlerForPagination;
            let lastIDArr = lastIdHandlerForPagination;
            firstIDArr.push(response && response.first_id);
            lastIDArr.push(response && response.last_id);
            setFirstIdHandlerForPagination(firstIDArr);
            setLastIdHandlerForPagination(lastIDArr);
            // For Pagination Part
            setLoading(false)
        });
    }


    // console.log('pagination', firstIdHandlerForPagination, lastIdHandlerForPagination)



    let handleEdit = (record) => {
        setSingleData(
            {
                sector_id: record.id,
                record_data: record
            }
        )
    }

    let handleShowTrashAlert = (uid) => {
        // console.log(showTrashAlert, uid)
        setShowTrashAlert({ uid: uid, show: !showTrashAlert.show });
    }

    let handleAlertResponse = () => {
        handleDelete();
    }

    let handleDelete = () => {
        setLoading(true);
        let data = {
            server_id: server_id,
            visit_id: showTrashAlert.uid,
        };
        dispatch(trash(data)).then(() => {
            setLoading(true);
            data = {
                server_id: server_id,
                limit: record_length,
                last_id: '',
                first_id: '',
            };
            dispatch(retrieve(data)).then(() => {
                setLoading(false);
                setTimeout(() => {
                    setShowTrashAlert({ show: !showTrashAlert.show });
                }, 1000);
            });
        });
    }



    let handleUpdateActivity = (visit_id) => {
        setCreateModalVisibilityActivity(!createModalVisibilityActivity);
    }

    let handleUpdateDate = (visit_id) => {
        setCreateModalVisibilityDate(!createModalVisibilityDate);
    }

    let handleUpdateTime = (visit_id) => {
        setCreateModalVisibilityTime(!createModalVisibilityTime);
    }

    let handleUpdateRecomandation = (visit_id) => {
        setCreateModalVisibilityStaff(!createModalVisibilityStaff);
    }





    return (
        <>
            {loading ?
                <div>
                    <Placeholder.Paragraph rows={8} />
                    <Loader center content="loading" />
                </div>
                :
                <>
                    <div className="d-sm-flex justify-content-between align-items-center mb-4">
                        <h3 className="text-dark mb-0">Server Visits</h3>
                        <div>
                            {/* <NavLink className="btn btn-primary btn-sm d-none d-sm-inline-block ml-15" role="button" to={`/Architecture/Servers/${server_id}/VisitsCalenderView`}>Calendar View</NavLink> */}
                            <a className="btn btn-primary btn-sm d-none d-sm-inline-block ml-15" role="button" href="javascript:void(0)" onClick={handleCreateModalVisibility}>
                                <i className="fas fa-plus fa-sm"></i>&nbsp;Add New Visit
                            </a>
                        </div>
                        <Popup visibility_status={createModalVisibility} updateParentState={updateParentState}><ArchitectureServerVisitsAddModal updateParentState={updateParentState} /></Popup>
                        <Popup visibility_status={createModalVisibilityActivity} updateParentStateActivity={updateParentStateActivity}><ArchitectureServerVisitsActivityModal visit_id={visit_id} updateParentStateActivity={updateParentStateActivity} /></Popup>
                        <Popup visibility_status={createModalVisibilityDate} updateParentStateDate={updateParentStateDate}><ArchitectureServerVisitsDateModal visit_id={visit_id} updateParentStateDate={updateParentStateDate} /></Popup>
                        <Popup visibility_status={createModalVisibilityTime} updateParentStateTime={updateParentStateTime}><ArchitectureServerVisitsTimeModal visit_id={visit_id} updateParentStateTime={updateParentStateTime} /></Popup>
                        <Popup visibility_status={createModalVisibilityStaff} updateParentStateStaff={updateParentStateStaff}><ArchitectureServerVisitsStaffModal visit_id={visit_id} updateParentStateStaff={updateParentStateStaff} /></Popup>
                    </div>
                    <div className="card shadow hidden-xs">
                        {/* <div className="card-header py-3">
                    <p className="text-primary m-0 fw-bold">Server List</p>
                </div> */}
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 text-nowrap">
                                    <div id="dataTable_length" className="dataTables_length" aria-controls="dataTable">
                                        <label className="form-label">Show&nbsp;
                                            <select className="d-inline-block form-select form-select-sm" name='record_length' defaultValue={record_length} onChange={handleChange}>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>
                                {/* <div className="col-md-6">
                                    <div className="text-md-end dataTables_filter" id="dataTable_filter"><label className="form-label"><input type="search" className="form-control form-control-sm" aria-controls="dataTable" placeholder="Keyword Search" /></label></div>
                                </div> */}
                            </div>
                            <div className="table-responsive table mt-2" id="dataTable" role="grid" aria-describedby="dataTable_info">
                                <table className="table my-0" id="dataTable">
                                    <thead>
                                        <tr>
                                            <th>Visit Id</th>
                                            <th>Activities</th>
                                            <th>Date</th>
                                            <th>Staff</th>
                                            <th>User</th>
                                            <th>Start Time</th>
                                            {/* <th>End Time</th> */}
                                            <th>Cancelled</th>
                                            <th style={{ width: "" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            server_visits_data &&
                                                server_visits_data.data &&
                                                // server_visits_data.data.length > 0 && 
                                                server_visits_data.data.visits &&
                                                server_visits_data.data.visits.length > 0 ?
                                                server_visits_data.data.visits.map((val, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{val.visit_id}</td>
                                                            <td>{val.activities}</td>
                                                            <td>{val.date}</td>
                                                            <td>{val.staff_ids}</td>
                                                            <td>{val.user_id}</td>
                                                            <td>{val.start_time}</td>
                                                            {/* <td>{val.end_time}</td> */}
                                                            <td>{val.cancelled}</td>
                                                            <td>
                                                                {/* <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateActivity(val.visit_id)}><i className="fas fa-capsules fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateDate(val.visit_id)}><i className="fas fa-calendar fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateTime(val.visit_id)}><i className="fas fa-clock fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateRecomandation(val.visit_id)}><i className="fas fa-users fg-theme"></i></button> */}

                                                                {/* <NavLink to={`/Architecture/Servers/${server_id}/Visits/${val.visit_id}/Edit`}><button type='button' className='btn btn-light btn-sm mr-15'><i className="fas fa-edit"></i></button></NavLink> */}
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleShowTrashAlert(val.visit_id)}><i className="fas fa-trash fg-theme"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : ''
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <div className="col-md-6 align-self-center">
                                    <p id="dataTable_info" className="dataTables_info" role="status" aria-live="polite">Total Records {server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 0}</p>
                                </div>
                                <div className="col-md-6">
                                    <nav className="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers">
                                        <ul className="pagination">
                                            {page ?
                                                <li className={page ? "page-item" : "page-item disabled"} onClick={handlePrev}><a className="page-link" aria-label="Previous" href="#"><span aria-hidden="true">«</span> Previous</a></li>
                                                : ''}
                                            {(page <= (parseInt((server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 1) / record_length) - 1)) ?
                                                <li className={(page <= (parseInt((server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 1) / record_length) - 1)) ? "page-item" : "page-item disabled"} onClick={handleNext}><a className="page-link" aria-label="Next" href="#">Next <span aria-hidden="true">»</span></a></li>
                                                : ''}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <SweetAlert
                                show={showTrashAlert.show}
                                title=""
                                text="Are you sure you want to permanently delete this record?"
                                onCancel={() => handleShowTrashAlert(false)}
                                showCancelButton
                                onConfirm={handleAlertResponse}
                            />
                        </div>
                    </div>
                    <div className="row shown-xs">
                        <div className="container-fluid text-nowrap">
                            <div id="dataTable_length" className="dataTables_length" aria-controls="dataTable">
                                <label className="form-label">Show&nbsp;
                                    <select className="d-inline-block form-select form-select-sm" name='record_length' defaultValue={record_length} onChange={handleChange}>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                {
                                    server_visits_data &&
                                        server_visits_data.data &&
                                        // server_visits_data.data.length > 0 && 
                                        server_visits_data.data.visits &&
                                        server_visits_data.data.visits.length > 0 ?
                                        server_visits_data.data.visits.map((val, index) => {
                                            return (
                                                <div className="col-md-6 mt-2">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div className='align-right'>
                                                                {/* <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateActivity(val.visit_id)}><i className="fas fa-capsules fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateDate(val.visit_id)}><i className="fas fa-calendar fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateTime(val.visit_id)}><i className="fas fa-clock fg-theme"></i></button>
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleUpdateRecomandation(val.visit_id)}><i className="fas fa-users fg-theme"></i></button> */}

                                                                {/* <NavLink to={`/Architecture/Servers/${server_id}/Visits/${val.visit_id}/Edit`}><button type='button' className='btn btn-light btn-sm mr-15'><i className="fas fa-edit"></i></button></NavLink> */}
                                                                <button type='button' className='btn btn-light btn-sm mr-15' onClick={() => handleShowTrashAlert(val.visit_id)}><i className="fas fa-trash fg-theme"></i></button>
                                                            </div>
                                                        </div>
                                                        <div className="card-body shown-xs">
                                                            <p><b>Visit ID</b>: {val.visit_id}</p>
                                                            <p><b>Activity</b>: {val.activities}</p>
                                                            <p><b>Date</b>: {val.date}</p>
                                                            <p><b>Staff</b>: {val.staff_ids}</p>
                                                            <p><b>User</b>: {val.user_id}</p>
                                                            <p><b>Start Time</b>: {val.start_time}</p>
                                                            {/* <p><b>End Time</b>: {val.end_time}</p> */}
                                                            <p><b>Cancelled ? </b>: {val.cancelled}</p>
                                                            {/* <h5><NavLink to={`/Architecture/Servers/${server_id}/Staff/${val.username}/Details`}>{val.username}</NavLink></h5>
                                                            <br />
                                                            <p><b>Full Name</b>: <br />{val.full_name} <sup><small><i className={`fa fa-circle ${val.activeNow ? 'fg-green' : ''}`}></i></small></sup></p>
                                                            <p><b>Type</b>: <br />{val.type}</p>
                                                            <p><b>Email Address</b>: <br />{val.email}</p>
                                                            <p><b>Phone Number</b>: <br />{val.phone_number}</p>
                                                            <p><b>Date of Birth</b>: <br />{val.dob}</p>
                                                            <p><b>Nationality</b>: <br />{val.nationality}</p>
                                                            <p><b>Gender</b>: <br />{val.gender}</p>
                                                            <p><b>Status</b>: <br />{val.uid ?
                                                                <td><i onClick={() => toggleStatus(val)} className={!val.status ? 'fa fa-toggle-off fg-red' : 'fa fa-toggle-on fg-green'}></i></td>
                                                                :
                                                                <td><i className={'fa fa-toggle-off'}></i></td>
                                                            }
                                                            </p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 align-self-center">
                                    <p id="dataTable_info" className="dataTables_info text-center mt-4" role="status" aria-live="polite">Total Records {server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 0}</p>
                                </div>
                                <div className="col-md-12 text-right">
                                    <nav className="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers">
                                        <ul className="pagination">
                                            {page ?
                                                <li className={page ? "page-item" : "page-item disabled"} onClick={handlePrev}><a className="page-link" aria-label="Previous" href="#"><span aria-hidden="true">«</span> Previous</a></li>
                                                : ''}
                                            {(page <= (parseInt((server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 1) / record_length) - 1)) ?
                                                <li className={(page <= (parseInt((server_visits_data && server_visits_data.data && server_visits_data.data.total ? server_visits_data.data.total : 1) / record_length) - 1)) ? "page-item align-right" : "page-item align-right disabled"} onClick={handleNext}><a className="page-link" aria-label="Next" href="#">Next <span aria-hidden="true">»</span></a></li>
                                                : ''}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
